import React from 'react';
import Paper from 'components/Paper';

const FindAccountErrorView = () => (
  <>
    <h1>Sorry we&apos;re having some problems.</h1>
    <p>
      We&apos;re very sorry.
      We&apos;re having some difficulties accessing your account.
      To fix this, please call the number below
    </p>
    <Paper>
      <h1>Widget coming soon</h1>
    </Paper>
  </>
);

FindAccountErrorView.displayName = 'FindAccountErrorView';

export default FindAccountErrorView;
